{
  "includedProducts": {
    "seatWifi": {
      "text": {
        "WIAL": "{seatType} {seatNumber} + Full flight Browse package",
        "WIEF": "{seatType} {seatNumber} + Full flight Stream package"
      },
      "title": "Seat + Wifi"
    },
    "bundle": {
      "title": "Combos"
    },
    "priorityServices": {
      "text": "{displayName}"
    }
  },
  "services": {
    "bundle": {
      "amount": {
        "seatWifi": "{amount} x Seat + Internet access"
      },
      "summary-title": "Combos",
      "seatWifi": "Seat + Internet access"
    },
    "priority": {
      "paid": "{amount} x Priority services",
      "state": {
        "purchased": {
          "default": "No priority services confirmed yet",
          "plural": "{numberOfItems} priority services confirmed",
          "singular": "1 priority service confirmed"
        },
        "selection": {
          "default": "No priority services selected yet",
          "plural": "{numberOfItems} priority services waiting in the cart",
          "singular": "1 priority service waiting in the cart"
        }
      }
    }
  },
  "notifications": {
    "tripContainsTrain": {
      "link": {
        "url": "#"
      }
    }
  },
  "thirdparty": {
    "expedia": {
      "nonSupportedLanguageWidget": {
        "collectAvios": "Collect Avios",
        "title": "Book a hotel in {cityName} and collect Avios",
        "description": "View our partner's hotel offers and collect Avios booking your stay in advance.",
        "ctaButton": "View hotel offers",
        "poweredBy": "Powered by"
      }
    }
  }
}
